<template>
  <div
    class="wrapper"
    style="width: 1200px; padding: 0 0 20px 0; margin: 0; overflow: hidden"
  >
    <el-row
      :gutter="20"
      style="width: 100%; margin-left: -0px; margin-right: -10px"
    >
      <el-col :span="5" style="padding: 0">
        <div class="leftmenu">
          <div class="title" @click="dialogTableVisible = true">
            角色账号管理
            <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
            <!-- <div style="float:right;margin-right:10px;">
                            <a @click="addcount" v-if="glytype!='headmaster' || user.style=='2'">
                                <img src="../../../static/images/systemConfig/add.png" />
                            </a>
                        </div> -->
          </div>
          <div class="treepanel" style="height: 650px; overflow: auto">
            <el-tree
              ref="loudongtree"
              v-show="glytype == 'housekeeper'"
              :props="defaultProps"
              @node-click="findsushemanagerload"
              :expand-on-click-node="false"
              :data="treeData"
              node-key="id"
              class="combotree"
            >
            </el-tree>
            <el-tree
              ref="classtree"
              v-show="glytype == 'headmaster'"
              :props="classdefaultProps"
              @node-click="findclassmanagerload"
              :expand-on-click-node="false"
              :data="waiclasstreeData"
              node-key="id"
              class="combotree"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.type == 1">
                  <span class="label-text">{{ node.label }}</span>
                </span>
                <span v-if="data.type == 2 || data.type == 6">
                  <span class="label-text icon-college">{{ node.label }}</span>
                </span>
                <span v-if="data.type == 3">
                  <span class="label-text icon-department">{{
                    node.label
                  }}</span>
                </span>
                <span v-if="data.type == 4">
                  <span class="label-text icon-grade">{{ node.label }}</span>
                </span>
                <span v-if="data.type == 5">
                  <span class="label-text icon-class">{{ node.label }}</span>
                </span>
              </span>
            </el-tree>
            <el-tree
              ref="loudongtree"
              v-show="glytype == 'admin'"
              :props="defaultProps"
              @node-click="findadminmanagerload"
              :expand-on-click-node="false"
              :data="admintreeData"
              node-key="id"
              class="combotree"
            >
            </el-tree>
            <el-tree
              ref="loudongtree"
              v-show="glytype == 'logisticsadmin'"
              :props="defaultProps"
              @node-click="findLogisticsadminManagerload"
              :expand-on-click-node="false"
              :data="admintreeData"
              node-key="id"
              class="combotree"
            >
            </el-tree>
            <!-- <el-tree ref="classtree" v-show="!iflong" default-expand-all :props="classdefaultProps" :expand-on-click-node="false" @click="searchrole" :data="classtreeData" node-key='id' style="width:170px" class="combotree">
						</el-tree> -->
          </div>
        </div>
      </el-col>
      <el-col :span="19" style="padding: 0">
        <div class="righttable">
          <div>
            <div class="operation-panel">
              <span style="font-size: 14px">账号类型: </span>
              <el-select
                lable="账号类型"
                v-model="glytype"
                @change="typechange"
              >
                <el-option
                  v-for="item in counttypelist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
              <!-- <span class="btn import" @click="showImport=true" v-if="user.style == '2'">
                                导入班主任
                            </span> -->

              <el-input
                class="input"
                placeholder="请输入姓名或者账号查询"
                v-model="search"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="queryRoomByName"
                  >查询</el-button
                >
              </el-input>
            </div>
            <el-table
              key="admin"
              border
              stripe
              :data="admintableData"
              header-row-class-name="table-header"
              fit
              v-if="glytype == 'admin'"
            >
              <el-table-column
                prop="indexorder"
                label="序号"
                width="45"
                align="center"
                type="index"
              >
              </el-table-column>
              <el-table-column prop="userName" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="account" label="账号" align="center">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" align="center">
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                width="40"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
                  <img
                    v-if="scope.row.status == 1"
                    src="../../../static/images/systemConfig/islocked.png"
                  />
                  <img
                    v-if="scope.row.status == 0"
                    src="../../../static/images/systemConfig/tingyong.png"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="mobile" label="联系电话" align="center">
              </el-table-column>
              <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
            </el-table>
            <el-table
              key="logisticsadmin"
              border
              stripe
              :data="logisticsadmintableData"
              header-row-class-name="table-header"
              fit
              v-if="glytype == 'logisticsadmin'"
            >
              <el-table-column
                prop="indexorder"
                label="序号"
                width="45"
                align="center"
                type="index"
              >
              </el-table-column>
              <el-table-column prop="userName" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="account" label="账号" align="center">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" align="center">
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                width="40"
                align="center"
              >
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.status == 1"
                    src="../../../static/images/systemConfig/islocked.png"
                  />
                  <img
                    v-if="scope.row.status == 0"
                    src="../../../static/images/systemConfig/tingyong.png"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="mobile" label="联系电话" align="center">
              </el-table-column>
            </el-table>
            <el-table
              key="housekeeper"
              border
              stripe
              :data="tableData"
              header-row-class-name="table-header"
              fit
              v-if="glytype == 'housekeeper'"
            >
              <el-table-column
                label="序号"
                width="45"
                align="center"
                type="index"
              >
              </el-table-column>
              <el-table-column prop="userName" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="account" label="账号" align="center">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" align="center">
              </el-table-column>
              <el-table-column label="状态" width="40" align="center">
                <template slot-scope="scope">
                  <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
                  <img
                    v-if="scope.row.status == 1"
                    src="../../../static/images/systemConfig/islocked.png"
                  />
                  <img
                    v-if="scope.row.status == 0"
                    src="../../../static/images/systemConfig/tingyong.png"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="campusName" label="校区" align="center">
              </el-table-column>
              <el-table-column
                prop="houseName"
                label="楼栋"
                align="center"
                :formatter="classInfoshouseName"
              >
              </el-table-column>
              <el-table-column prop="mobile" label="联系电话" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center" width="140px">
                <template slot-scope="scope">
                  <a @click="edithousekeeper(scope.row)">楼栋设置</a>
                  <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
                </template>
              </el-table-column>
            </el-table>
            <el-table
              key="headmaster"
              border
              stripe
              :data="headmastertableData"
              header-row-class-name="table-header"
              fit
              v-if="glytype == 'headmaster'"
            >
              <el-table-column
                prop="indexorder"
                label="序号"
                width="45"
                align="center"
                type="index"
              >
              </el-table-column>
              <el-table-column prop="userName" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="account" label="账号" align="center">
              </el-table-column>
              <el-table-column
                prop="roleName"
                label="角色"
                width="65"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                width="40"
                align="center"
                v-if="user.style == '2'"
              >
                <template slot-scope="scope">
                  <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对角色的管理，本页只保留查询和导出以及宿舍管理员管理角色楼栋的按钮-->
                  <img
                    v-if="scope.row.status == 1"
                    src="../../../static/images/systemConfig/islocked.png"
                  />
                  <img
                    v-if="scope.row.status == 0"
                    src="../../../static/images/systemConfig/tingyong.png"
                  />
                </template>
              </el-table-column>

              <el-table-column
                prop="className"
                label="班级"
                width="120"
                align="center"
                :formatter="classInfosclassName"
              >
                <!-- <template slot-scope="scope">
									<span v-for="item in scope.row.classInfos" :key="item.className">{{item.className}},</span>
								</template> -->
              </el-table-column>
              <el-table-column
                prop="gradeName"
                label="年级"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.classInfos[0].gradeName }}
                </template>
              </el-table-column>
              <el-table-column
                prop="departName"
                label="系"
                align="center"
                v-if="user.style !== K12TYPE"
              >
                <template slot-scope="scope">
                  {{ scope.row.classInfos[0].departName }}
                </template>
              </el-table-column>
              <el-table-column
                prop="collegeName"
                label="学院"
                align="center"
                v-if="user.style !== K12TYPE"
              >
                <template slot-scope="scope">
                  {{ scope.row.classInfos[0].collegeName }}
                </template>
              </el-table-column>
              <el-table-column
                prop="campusName"
                label="校区"
                align="center"
                v-else
              >
              </el-table-column>
              <el-table-column prop="mobile" label="联系电话" align="center">
              </el-table-column>
            </el-table>
            <div class="pagination-container">
              <v-pagination
                @pageChange="onCurrentChange"
                :page="page"
                :total="total"
                :size="size"
                :isShow="showPagination"
              ></v-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <import-upload
      :showImport.sync="showImport"
      :importObj="importObj"
      @importFinishCallback="afterimport"
    ></import-upload>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="roleauthor"
      title="添加账号"
      :visible.sync="addcountshow"
      width="687px"
      height="500px"
      left
    >
      <el-row style="height: 40px; line-height: 40px">
        <img
          src="../../../static/images/systemConfig/xinzeng.png"
          style="vertical-align: middle"
        />&nbsp;&nbsp;带<span style="color: red">*</span>号的为必填项
      </el-row>
      <div v-show="newadmin">
        <el-form
          :model="MasterDetailform"
          v-show="addcountshow"
          :rules="newadminDetailformrulesadmin"
          ref="adminDetailformrulesform"
        >
          <el-row :gutter="20">
            <el-col :span="7">
              <el-form-item prop="teaching" label="" style="text-align: center">
                <div
                  style="
                    background: url(../../static/images/systemConfig/bzrtx.png);
                    width: 157px;
                    height: 157px;
                    background-size: cover;
                    margin: auto;
                  "
                >
                  <img
                    v-show="img"
                    :src="img"
                    style="width: 157px; height: 157px"
                  />
                </div>
                <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
                <v-uploadfile
                  @upload="UploadFilenew"
                  :acceptType="acceptType"
                  :maxFileSize="maxFileSize"
                  :buttonname="buttonname"
                  ref="uploadfile"
                ></v-uploadfile>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <el-col :span="24">
                <el-form-item prop="roleCode" label="选择角色">
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-show="user.style == '2'"
                  >
                    <el-radio
                      v-for="item in counttypelist"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-show="user.style == '1'"
                  >
                    <el-radio
                      v-for="item in counttypelist1"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    v-model="MasterDetailform.userName"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="account" label="账号">
                  <el-input
                    v-model="MasterDetailform.account"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                  <el-input
                    v-model="MasterDetailform.password"
                    type="password"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    v-model="MasterDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="3" style="margin-top: 20px">
                <el-button @click="newsubmitform" type="primary" class="u-btn"
                  >确定</el-button
                >
                <el-button class="u-btn" @click="addcountshow = false"
                  >取消</el-button
                >
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-show="newkeeper">
        <el-form
          :model="MasterDetailform"
          v-show="addcountshow"
          :rules="newkeeperDetailformrules"
          ref="keeperDetailformrulesform"
        >
          <el-row :gutter="20">
            <el-col :span="7">
              <el-form-item prop="teaching" label="" style="text-align: center">
                <div
                  style="
                    background: url(../../static/images/systemConfig/bzrtx.png);
                    width: 157px;
                    height: 157px;
                    background-size: cover;
                    margin: auto;
                  "
                >
                  <img
                    v-show="img"
                    :src="img"
                    style="width: 157px; height: 157px"
                  />
                </div>
                <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
                <v-uploadfile
                  @upload="UploadFilenew"
                  :acceptType="acceptType"
                  :maxFileSize="maxFileSize"
                  :buttonname="buttonname"
                  ref="uploadfile"
                ></v-uploadfile>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <el-col :span="24">
                <el-form-item prop="roleCode" label="选择角色">
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-if="user.style == '2'"
                  >
                    <el-radio
                      v-for="item in counttypelist"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-if="user.style == '1'"
                  >
                    <el-radio
                      v-for="item in counttypelist1"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    v-model="MasterDetailform.userName"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="account" label="账号">
                  <el-input
                    v-model="MasterDetailform.account"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    v-model="MasterDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                  <el-input
                    v-model="MasterDetailform.password"
                    type="password"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="" label="选择校区">
                  <el-select
                    v-model="schoolarea"
                    @change="changeSchoolCapmusHouse"
                  >
                    <el-option
                      v-for="item in schoolarealist"
                      :key="item.schoolNum"
                      :label="item.schoolName"
                      :value="item.schoolNum"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="houseIds" label="管理宿舍">
                  <el-checkbox-group v-model="MasterDetailform.houseIds">
                    <el-checkbox
                      v-for="city in campusHouseList"
                      :label="city.houseId"
                      :key="city.houseId"
                      >{{ city.houseName }}</el-checkbox
                    >
                    <!-- <el-checkbox v-for="city in campusHouseList" :label="city.houseId" :key="city.houseId" disabled v-if="city.manageUser" title="此楼栋已经有宿舍管理员">{{city.houseName}}</el-checkbox> -->
                  </el-checkbox-group>
                </el-form-item>
                <el-col :span="24" :offset="3" style="margin-top: 20px">
                  <el-button
                    @click="newkeeperDetailformsubmitform"
                    type="primary"
                    class="u-btn"
                    >确定</el-button
                  >
                  <el-button class="u-btn" @click="addcountshow = false"
                    >取消</el-button
                  >
                </el-col>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-show="newmaster">
        <el-form
          :model="MasterDetailform"
          v-show="addcountshow"
          :rules="MasterDetailformrules"
          ref="MasterDetailformrulesform"
        >
          <el-row :gutter="20">
            <el-col :span="7">
              <el-form-item prop="teaching" label="" style="text-align: center">
                <div
                  style="
                    background: url(../../static/images/systemConfig/bzrtx.png);
                    width: 157px;
                    height: 157px;
                    background-size: cover;
                    margin: auto;
                  "
                >
                  <img
                    v-show="img"
                    :src="img"
                    style="width: 157px; height: 157px"
                  />
                </div>
                <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
                <v-uploadfile
                  @upload="UploadFilenew"
                  :acceptType="acceptType"
                  :maxFileSize="maxFileSize"
                  :buttonname="buttonname"
                  ref="uploadfile"
                ></v-uploadfile>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <el-col :span="24">
                <el-form-item prop="roleCode" label="选择角色">
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-if="user.style == '2'"
                  >
                    <el-radio
                      v-for="item in counttypelist"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                  <el-radio-group
                    v-model="MasterDetailform.roleCode"
                    @change="changecount"
                    v-if="user.style == '1'"
                  > 
                    <el-radio
                      v-for="item in counttypelist1"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    v-model="MasterDetailform.userName"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="account" label="账号">
                  <el-input
                    v-model="MasterDetailform.account"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    v-model="MasterDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                  <el-input
                    v-model="MasterDetailform.password"
                    type="password"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="classIds" label="班级（带多个班可多选）">
                  <el-input
                    v-model="MasterDetailform.classIdsname"
                    readonly
                    placeholder="请选择或者输入部门"
                    @click.native="deptValueShow = !deptValueShow"
                    suffix-icon="el-icon-arrow-down"
                  ></el-input>
                  <el-input
                    v-model="MasterDetailform.classIds"
                    style="visibility: hidden; height: 0; width: 0"
                  ></el-input>
                  <el-tree
                    default-expand-all
                    ref="classtreenew"
                    show-checkbox
                    :style="deptValueShow ? 'height:304px' : 'height:0'"
                    :data="classtreeData"
                    :props="classdefaultProps"
                    node-key="id"
                    :expand-on-click-node="false"
                    @check="deptTreeNodeHandleClick"
                    style="width: 475px"
                    class="combotree"
                  >
                  </el-tree>
                </el-form-item>
                <el-col :span="24" :offset="3" style="margin-top: 20px">
                  <el-button
                    @click="newMasterDetailformsubmitform"
                    type="primary"
                    class="u-btn"
                    >确定</el-button
                  >
                  <el-button class="u-btn" @click="addcountshow = false"
                    >取消</el-button
                  >
                </el-col>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="设置楼栋"
      :visible.sync="edithousekeeperduakig"
      width="687px"
      height="500px"
      left
    >
      <el-form
        :model="keeperDetailform"
        v-if="edithousekeeperduakig"
        ref="keeperDetailform"
        :rules="keeperDetailformrules"
      >
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item prop="teaching" label="" style="text-align: center">
              <div
                style="
                  background: url(../../static/images/systemConfig/bzrtx.png);
                  width: 157px;
                  height: 157px;
                  background-size: cover;
                  margin: auto;
                "
              >
                <img
                  v-show="img"
                  :src="img"
                  style="width: 157px; height: 157px"
                />
              </div>
              <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
              <!-- <v-uploadfile
                                @upload="UploadFile"
                                :acceptType='acceptType'
                                :maxFileSize='maxFileSize'
                                :buttonname="buttonname"
                                ref="uploadfile"
                            ></v-uploadfile> -->
            </el-form-item>
          </el-col>
          <el-col :span="17" style="padding: 0">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    disabled
                    v-model="keeperDetailform.userName"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    disabled
                    v-model="keeperDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="account" label="账号">
                  <el-input
                    disabled
                    v-model="keeperDetailform.account"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="schoolarea" label="选择校区">
                  <el-select
                    v-model="schoolarea"
                    @change="changeSchoolCapmusHouse"
                  >
                    <el-option
                      v-for="item in schoolarealist"
                      :key="item.schoolNum"
                      :label="item.schoolName"
                      :value="item.schoolNum"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="houseIds" label="管理宿舍">
                  <el-checkbox-group v-model="keeperDetailform.houseIds">
                    <el-checkbox
                      v-for="city in campusHouseList"
                      :label="city.houseId"
                      :key="city.houseId"
                      >{{ city.houseName }}</el-checkbox
                    >
                    <!-- <el-checkbox v-for="city in campusHouseList" :label="city.houseId" :key="city.houseId" disabled v-if="city.manageUser" title="此楼栋已经有宿舍管理员">{{city.houseName}}</el-checkbox> -->
                  </el-checkbox-group>
                </el-form-item>
                <!-- <el-col :span="24" style="    margin-top: 20px;">
                                    <el-button @click="submitkeeperDetailform" type="primary" class="u-btn">确定</el-button>
									<el-button class="u-btn" @click="edithousekeeperduakig=false">取消</el-button>
								</el-col> -->
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitkeeperDetailform" type="primary" class="u-btn"
          >确定</el-button
        >
        <el-button class="u-btn" @click="edithousekeeperduakig = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="roleauthor"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑班主任"
      :visible.sync="edithousemasterduakig"
      width="687px"
      height="469px"
      left
    >
      <el-form
        :model="MasterDetailform"
        v-show="edithousemasterduakig"
        ref="MasterDetailform"
        :rules="MasterDetailformrules"
      >
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item prop="teaching" label="">
              <div
                style="
                  background: url(../../static/images/systemConfig/bzrtx.png);
                  width: 157px;
                  height: 157px;
                  background-size: cover;
                  margin: auto;
                "
              >
                <img
                  v-show="img"
                  :src="img"
                  style="width: 157px; height: 157px"
                />
              </div>
              <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
              <v-uploadfile
                @upload="UploadFile"
                :acceptType="acceptType"
                :maxFileSize="maxFileSize"
                :buttonname="buttonname"
                ref="uploadfile"
              ></v-uploadfile>
            </el-form-item>
          </el-col>
          <el-col :span="17" style="padding: 0">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    v-model="MasterDetailform.userName"
                    v-inputexclude="'\\s+'"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    v-model="MasterDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item
                  prop="account"
                  label="账号"
                  v-inputexclude="'\\s+'"
                  maxlength="20"
                >
                  <el-input v-model="MasterDetailform.account"></el-input>
                </el-form-item>
                <el-form-item prop="classIds" label="班级（带多个班可多选）">
                  <el-input
                    v-model="MasterDetailform.className"
                    readonly
                    placeholder="请选择或者输入部门"
                    @click.native="showdeptValueShow"
                    suffix-icon="el-icon-arrow-down"
                  ></el-input>
                  <el-input
                    v-model="MasterDetailform.classIds"
                    style="visibility: hidden; height: 0; width: 0"
                  ></el-input>
                  <el-tree
                    default-expand-all
                    ref="classtreeedit"
                    show-checkbox
                    :style="deptValueShow ? 'height:304px' : 'height:0'"
                    :data="waiclasstreeData"
                    :props="classdefaultProps"
                    node-key="relId"
                    :expand-on-click-node="false"
                    @check="editdeptTreeNodeHandleClick"
                    style="width: 475px"
                    class="combotree"
                  >
                  </el-tree>
                </el-form-item>
                <!-- <el-col :span="24" style="    margin-top: 20px;">
									<el-button @click="submitMasterDetailform" type="primary" class="u-btn">确定</el-button>
									<el-button @click="edithousemasterduakig=false" class="u-btn">取消</el-button>
								</el-col> -->
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitMasterDetailform" type="primary" class="u-btn"
          >确定</el-button
        >
        <el-button @click="edithousemasterduakig = false" class="u-btn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="roleauthor"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑学校管理员"
      :visible.sync="editadmin"
      width="687px"
      height="469px"
      left
    >
      <el-form
        :model="adminDetailform"
        v-if="editadmin"
        :rules="adminDetailformrules"
        ref="adminDetailform"
      >
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item prop="teaching" label="">
              <div
                style="
                  background: url(../../static/images/systemConfig/bzrtx.png);
                  width: 157px;
                  height: 157px;
                  background-size: cover;
                  margin: auto;
                "
              >
                <img
                  v-show="img"
                  :src="img"
                  style="width: 157px; height: 157px"
                />
              </div>
              <!-- <img src="/suguan/oss/i/Wi85L3N1Z3Vhbi8yMDE4LzA4LzEzLzgyYTlmYWI3MjFlMjRiYzA4Y2ViMjg5M2JjNTcyMmMwLmpwZw?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXNDb2RlIjoiIiwiYWNjb3VudElkIjoiNzExNjg4IiwiYWNjb3VudFVzZXJOYW1lIjoi5YiY5p2-5p2-Iiwic2Nob29sSWQiOiI5IiwidXNlck5hbWUiOiIxNzM3NTcxOTMwMiIsImV4cCI6MTUzNDE2MDM4NH0.eSamcMtqpmSY7rQppuGchVGzzCFXLdcZaBZ4AnDiUjI" style="width:157px;height:157px;"/>			  -->
              <v-uploadfile
                @upload="UploadFile"
                :acceptType="acceptType"
                :maxFileSize="maxFileSize"
                :buttonname="buttonname"
                ref="uploadfile"
              ></v-uploadfile>
            </el-form-item>
          </el-col>
          <el-col :span="17" style="padding: 0">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="userName" label="姓名">
                  <el-input
                    v-model="adminDetailform.userName"
                    maxlength="20"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="account" label="账号">
                  <el-input
                    v-model="adminDetailform.account"
                    maxlength="20"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="mobile" label="联系电话">
                  <el-input
                    v-model="adminDetailform.mobile"
                    maxlength="11"
                    v-inputexclude="'\\s+'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24" style="    margin-top: 20px;">
								<el-button @click="submitadminDetailform" type="primary" class="u-btn">确定</el-button>
								<el-button @click="editadmin=false" class="u-btn">取消</el-button>
							</el-col> -->
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitadminDetailform" type="primary" class="u-btn"
          >确定</el-button
        >
        <el-button @click="editadmin = false" class="u-btn">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api";
import { LOGIN, TOKEN } from "@/stores/types";
import vRules from "@/config/validate_rules";
import basetable from "@/mixins/base-table";
import store from "@/stores";
import { session } from "@/util";
import importUpload from "@/components/importUpload/importUpload.vue";
import { mapState } from "vuex";
export default {
  components: {
    importUpload,
  },
  mixins: [basetable],
  props: {},
  computed: {
    ...mapState(["K12TYPE", "UNK12TYPE"]),
  },
  data() {
    let validatePass = (rule, value, callback) => {
      let msg = "密码长度6~20位，只能由数字、字母和特殊字符组成";
      let regExp =
        /^([a-z0-9\.\,\。\{\}\[\]\|\:\;\'\"\<\>\?\/\\\-\+\@\!\#\$\%\^\&\*\(\)]){6,20}$/i;
      if (!regExp.test(value)) {
        callback(new Error(msg));
      }

      callback();
    };
    let validatePassaddadmin = (rule, value, callback) => {
      let msg = "密码长度6~20位，只能由数字、字母和特殊字符组成";
      let regExp =
        /^([a-z0-9\.\,\。\{\}\[\]\|\:\;\'\"\<\>\?\/\\\-\+\@\!\#\$\%\^\&\*\(\)]){6,20}$/i;
      if (!regExp.test(value)) {
        callback(new Error(msg));
      }

      callback();
    };
    let houseValidate = (rule, value, callback) => {
      if (
        !this.keeperDetailform.houseIds ||
        this.keeperDetailform.houseIds.length === 0
      ) {
        callback(new Error("楼栋不能为空！"));
        return;
      }
      callback();
    };
    const user = session("user");
    return {
      user: user,
      masterroldid: "",
      managerroldid: "",
      adminroldid: "",
      adminDetailformrules: {
        userName: [
          {
            required: true,
            message: "用户名不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            validator: validatePassaddadmin,
          },
        ],
      },
      newadminDetailformrulesadmin: {
        userName: [
          {
            required: true,
            message: "用户名不能为空！",
            trigger: "blur",
          },
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, validator: validatePassaddadmin, trigger: "blur" },
        ],
      },
      newkeeperDetailformrules: {
        userName: [
          {
            required: true,
            message: "用户名不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        houseIds: [
          {
            required: true,
            message: "楼栋不能为空！",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      keeperDetailformrules: {
        userName: [
          {
            required: true,
            message: "用户名不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        houseIds: [
          {
            required: true,
            message: "楼栋不能为空！",
            trigger: "blur",
            validator: houseValidate,
          },
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      MasterDetailformrules: {
        userName: [
          {
            required: true,
            message: "用户名不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur",
          },
          vRules.illegalCharacter,
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        classIds: [
          {
            required: true,
            message: "班级不能为空！",
            trigger: "blur",
          },
        ],
      },
      showImport: false,
      importObj: {
        title: "导入班主任",
        text: "点击下载班主任导入模板",
        url: "/static/班主任导入模板.xlsx",
        key: "classTeacherFile",
        api: Api.systemConfig.importClassTeacher,
      },
      search: "",

      editadmin: false,
      newkeeper: false,
      newmaster: false,
      newadmin: true,
      schoolarea: "",
      campusHouseList: [],
      keepertitle: "",
      mastertitle: "",
      acceptType: ".jpg,.jpeg",
      maxFileSize: 204800,
      buttonname: "上传照片",
      deptValueShow: false,
      schoolarealist: [],
      schoolarea: "",
      adminDetailform: {},
      keeperDetailform: {},
      MasterDetailform: {},

      classIdsname: [],
      edithousemasterduakig: false,
      loudongdialogVisible: false,
      edithousekeeperduakig: false,
      iflong: true,
      glytype: "admin",
      tableData: [],
      admintableData: [],
      logisticsadmintableData: [],
      headmastertableData: null,
      treeData: [],
      counttypelist: [
        {
          name: "学校管理员",
          id: "admin",
        },
        {
          name: "后勤管理员",
          id: "logisticsadmin",
        },
        {
          name: "宿舍管理员",
          id: "housekeeper",
        },
        {
          name: "班主任",
          id: "headmaster",
        },
      ],
      counttypelist1: [
        {
          name: "学校管理员",
          id: "admin",
        },
        {
          name: "宿舍管理员",
          id: "housekeeper",
        },
      ],
      defaultProps: {
        label: "lable",
        isLeaf: "leaf",
        children: "children",
      },
      classdefaultProps: {
        label: "directorName",
        isLeaf: "leaf",
        children: "nextLevels",
      },
      classtreeData: [],
      img: "",
      sugnode: {},
      bzrnode: {},
      addcountshow: false,
      adminnode: null,
      logisticsnode: null,
      admintreeData: [],
      waiclasstreeData: [],
    };
  },
  methods: {
    afterimport() {
      if (this.glytype == "housekeeper") {
        this.findsushemanager(this.sugnode);
      } else if (this.glytype == "headmaster") {
        this.findclassmanager(this.bzrnode);
      } else if (this.glytype == "logisticsadmin") {
        this.findLogisticsadminManager(this.logisticsnode);
      } else {
        this.findadminmanager(this.adminnode);
      }
    },
    classInfoshouseName(row, column, cellValue, index) {
      let houseName = [];
      if (row.houses) {
        let houses = row.houses;
        for (let index = 0; index < houses.length; index++) {
          const element = houses[index];
          houseName.push(element.houseName);
        }

        return houseName.join(",");
      } else {
        return "";
      }
    },
    classInfosclassName(row, column, cellValue, index) {
      let className = [];
      if (row.classInfos) {
        let classInfos = row.classInfos;
        for (let index = 0; index < classInfos.length; index++) {
          const element = classInfos[index];
          className.push(element.className);
        }

        return className.join(",");
      } else {
        return "";
      }
    },
    queryRoomByName() {
      this.typechange(this.glytype);
    },
    submitadminDetailform() {
      this.$refs.adminDetailform.validate((valid) => {
        if (valid) {
          Api.systemConfig.updUser(this.adminDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");
              let user = this.$store.getters.user;
              let token = this.$store.getters.token;
              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              this.edithousekeeperduakig = false;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                }  else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                }  else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.editadmin = false;
            } else {
              this.$message(res.message);
            }
          });
        }
      });
    },
    newMasterDetailformsubmitform() {
      let user = this.$store.getters.user;
      let token = this.$store.getters.token;
      let { style } = user;
      this.$refs.MasterDetailformrulesform.validate((valid) => {
        if (valid) {
          Object.assign(this.MasterDetailform, { style });
          Api.systemConfig.addUser(this.MasterDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");

              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                }  else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                }  else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.addcountshow = false;
            } else {
              this.$message(res.message);
            }
          });
        }
      });
    },
    newkeeperDetailformsubmitform() {
      let user = this.$store.getters.user;
      let token = this.$store.getters.token;
      var { style } = user;
      this.$refs.keeperDetailformrulesform.validate((valid) => {
        if (valid) {
          if (this.MasterDetailform.houseIds) {
            this.MasterDetailform.houseIds =
              this.MasterDetailform.houseIds.join(",");
          }
          Object.assign(this.MasterDetailform, { style });
          Api.systemConfig.addUser(this.MasterDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");
              let user = this.$store.getters.user;
              let token = this.$store.getters.token;
              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                }  else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                }   else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.addcountshow = false;
            } else {
              this.MasterDetailform.houseIds = [];
              this.$message(res.message);
            }
          });
        }
      });
    },
    newsubmitform() {
      let user = this.$store.getters.user;
      let token = this.$store.getters.token;
      var { style } = user;
      this.$refs.adminDetailformrulesform.validate((valid) => {
        if (valid) {
          Object.assign(this.MasterDetailform, { style });
          Api.systemConfig.addUser(this.MasterDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");

              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                } else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                }  else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.addcountshow = false;
            } else {
              this.$message(res.message);
            }
          });
        }
      });
    },
    submitkeeperDetailform() {
      this.$refs.keeperDetailform.validate((valid) => {
        if (valid) {
          this.keeperDetailform.houseIds =
            this.keeperDetailform.houseIds.join(",");
          Api.systemConfig.updUser(this.keeperDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");
              let user = this.$store.getters.user;
              let token = this.$store.getters.token;
              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              this.edithousekeeperduakig = false;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                } else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                } else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.addcountshow = false;
            } else {
              this.keeperDetailform.houseIds = [];

              this.$message(res.message);
            }
          });
        }
      });
    },

    submitMasterDetailform() {
      this.$refs.MasterDetailform.validate((valid) => {
        if (valid) {
          Api.systemConfig.updUser(this.MasterDetailform).then((res) => {
            if (res.code == 0) {
              this.$message("保存成功");
              let user = this.$store.getters.user;
              let token = this.$store.getters.token;
              let str = "accountId=" + user.accountId;
              str += "&sysCode=suguan";
              str += "&schoolId=" + user.schoolId;
              Api.systemConfig.queryUserInfo(str).then((res) => {
                user.userName = res.data.userName;
                user.account = res.data.account;
                user.mobile = res.data.mobile;
                this.$store.commit(LOGIN, user);
                if (this.glytype == "housekeeper") {
                  this.findsushemanager(this.sugnode);
                } else if (this.glytype == "logisticsadmin") {
                  this.findLogisticsadminManager(this.logisticsnode);
                } else if (this.glytype == "headmaster") {
                  this.findclassmanager(this.bzrnode);
                } else {
                  this.findadminmanager(this.adminnode);
                }
              });
              this.edithousemasterduakig = false;
            } else {
              this.$message(res.message);
            }
          });
        }
      });
    },
    UploadFilenew(newfilesarray) {
      var ossData = new FormData();
      ossData.append("file", newfilesarray[0]);
      Api.systemConfig.uploadFile(ossData).then((res) => {
        if (res.code == 0) {
          this.MasterDetailform.img = res.data;

          this.img = "/suguan/oss/i/" + res.data + "?token=" + res.token;
          this.buttonname = "更改照片";
        }
      });
    },
    UploadFile(newfilesarray) {
      var ossData = new FormData();
      ossData.append("file", newfilesarray[0]);
      Api.systemConfig.uploadFile(ossData).then((res) => {
        if (res.code == 0) {
          if (this.glytype == "admin") {
            this.adminDetailform.img = res.data;
          }
          if (this.glytype == "headmaster") {
            this.MasterDetailform.img = res.data;
          }
          if (this.glytype == "housekeeper") {
            this.keeperDetailform.img = res.data;
          }

          this.img = "/suguan/oss/i/" + res.data + "?token=" + res.token;
          this.buttonname = "更改照片";
        }
      });
    },
    editdeptTreeNodeHandleClick() {
      let self = this;
      let classIds = self.$refs.classtreeedit.getCheckedNodes();
      classIds = classIds.filter((res) => res.type == 5);
      let classidsarray = [];
      let classidsarrayname = [];
      for (let index = 0; index < classIds.length; index++) {
        const element = classIds[index];
        classidsarray.push(element.relId);
        classidsarrayname.push(element.directorName);
      }
      self.MasterDetailform.classIds = classidsarray.join(",");
      self.MasterDetailform.className = classidsarrayname.join(",");
    },
    deptTreeNodeHandleClick() {
      let self = this;
      let classIds = this.$refs.classtreenew.getCheckedNodes();

      classIds = classIds.filter((res) => res.type == 5);
      let classidsarray = [];
      let classidsarrayname = [];
      for (let index = 0; index < classIds.length; index++) {
        const element = classIds[index];
        classidsarray.push(element.relId);
        classidsarrayname.push(element.directorName);
      }
      self.MasterDetailform.classIds = classidsarray.join(",");
      self.MasterDetailform.classIdsname = classidsarrayname.join(",");
    },
    getSchoolarealist() {
      Api.summary.querySchoolCapmus().then((res) => {
        if (res.code == 0) {
          this.schoolarealist = res.data;
          this.schoolarea =
            this.schoolarealist.length > 0
              ? this.schoolarealist[0].schoolNum
              : "";
        }
      });
    },
    editadminfuc(item) {
      this.editadmin = true;
      this.img = null;
      let user = session("user");
      let token = session("token");
      Api.systemConfig.queryAdminById(item.accountId).then((res) => {
        if (res.code == 0) {
          this.adminDetailform = {
            roleId: this.adminroldid,
            roleCode: "admin",
            roleName: "学校管理员",
            mobile: res.data.mobile,
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: "",
            img: res.data.img,
            userName: res.data.userName,
            account: res.data.account,
            accountId: res.data.accountId,
            status: res.data.status,
          };
          this.$nextTick(() => {
            if (this.adminDetailform.img) {
              this.buttonname = "更改照片";
              this.img =
                "/suguan/oss/i/" +
                this.adminDetailform.img +
                "?token=" +
                token.accesstoken;
            } else {
              this.buttonname = "上传照片";
            }
          });
        }
      });
    },
    edithousekeeper(item) {
      let token = session("token");
      let user = session("user");
      this.edithousekeeperduakig = true;
      this.img = null;
      let self = this;
      Api.systemConfig.queryManagerById(item.accountId).then((res) => {
        if (res.code == 0) {
          let schoolarealist = null;
          // 该宿管员所在校区信息
          if (item.campusName) {
            let schoolarealist = self.schoolarealist.filter(
              (x) => x.schoolName === item.campusName
            );
          }
          // this.keeperDetailform = Object.assign({}, res.data);
          (self.keeperDetailform = {
            roleId: self.managerroldid,
            roleCode: "housekeeper",
            roleName: "宿舍管理员",
            houseIds: [],
            mobile: res.data.mobile,
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: "",
            img: res.data.img,
            userName: res.data.userName,
            account: res.data.account,
            accountId: res.data.accountId,
            status: res.data.status,
          }),
            this.$nextTick(() => {
              self.schoolarea = schoolarealist
                ? schoolarealist[0].schoolNum
                : "";
              self.changeSchoolCapmusHouseedit(self.schoolarea);

              let houses = res.data.houses;

              for (let index = 0; index < houses.length; index++) {
                const element = houses[index];
                self.keeperDetailform.houseIds.push(element.houseId);
              }

              if (self.keeperDetailform.img) {
                this.buttonname = "更改照片";
                self.img =
                  "/suguan/oss/i/" +
                  self.keeperDetailform.img +
                  "?token=" +
                  token.accesstoken;
              } else {
                this.buttonname = "上传照片";
              }
            });
        }
      });
    },
    edithousemaster(item) {
      let token = session("token");
      let user = session("user");
      this.mastertitle = "编辑班主任";
      this.edithousemasterduakig = true;
      this.img = null;
      let self = this;
      Api.systemConfig.queryMasterDetail(item.accountId).then((res) => {
        if (res.code == 0) {
          // this.MasterDetailform = res.data;

          this.MasterDetailform = {
            roleId: this.managerroldid,
            roleCode: "headmaster",
            roleName: "班主任",
            mobile: res.data.mobile,
            classIds: res.data.classIds,
            className: res.data.className,
            collegeName: res.data.collegeName,
            departName: res.data.departName,
            gradeName: res.data.gradeName,
            status: res.data.status,
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: res.data.userName,
            account: res.data.account,
            accountId: res.data.accountId,
            img: res.data.img,
          };
          this.$nextTick(() => {
            this.$refs.classtreeedit.setCheckedKeys(
              this.MasterDetailform.classIds.split(",")
            );
            let classIdsnode = this.$refs.classtreeedit.getCheckedNodes();
            classIdsnode = classIdsnode.filter((res) => res.level == 4);
            let classidsarrayname = [];
            for (let index = 0; index < classIdsnode.length; index++) {
              const element = classIdsnode[index];

              classidsarrayname.push(element.directorName);
            }
            this.MasterDetailform.className = classidsarrayname.join(",");
          });
          this.deptValueShow = false;

          let token = session("token");

          if (this.MasterDetailform.img) {
            this.buttonname = "更改照片";
            this.img =
              "/suguan/oss/i/" +
              this.MasterDetailform.img +
              "?token=" +
              token.accesstoken;
          } else {
            this.buttonname = "上传照片";
          }
        }
      });
    },
    showdeptValueShow() {
      this.deptValueShow = !this.deptValueShow;
    },
    findadminmanagerload() {
      this.page = 1;
      this.findadminmanager(Node);
    },
    findadminmanager(Node) {
      this.adminnode = Node;
      let user = session("user");
      let str = "";

      if (this.search) {
        str += "&userName=" + this.search;
      }
      Api.systemConfig.querySGAdmin(str, this.page, this.size).then((res) => {
        this.$nextTick(() => {
          this.admintableData = res.data.list;
          this.total = res.data.total;
        });
      });
    },
    findLogisticsadminManagerload() {
      this.page = 1;
      this.findLogisticsadminManager(Node);
    },
    //后勤管理员
    findLogisticsadminManager(Node) {
      this.logisticsnode = Node;
      let user = session("user");
      let str = "";

      if (this.search) {
        str += "&userName=" + this.search;
      }
      Api.systemConfig.queryHQAdmin(str, this.page, this.size).then((res) => {
        this.$nextTick(() => {
          this.logisticsadmintableData = res.data.list;
          this.total = res.data.total;
        });
      });
    },
    findsushemanagerload(Node) {
      this.page = 1;
      this.findsushemanager(Node);
    },
    findsushemanager(Node) {
      this.sugnode = Node;
      let user = store.getters.user;

      let str = "";
      str = "schoolId=" + user.schoolId;
      if (user.style == "1") {
        switch (Node.leavel) {
          case 1:
            str += "&schoolNum=" + Node.schoolNum;
            break;
          case 2:
            str += "&houseId=" + Node.id;
            break;
          default:
            break;
        }
      } else {
        switch (Node.leavel) {
          case 1:
            str += "&schoolNum=" + Node.schoolNum;
            break;
          case 2:
            str += "&houseId=" + Node.id;
            break;
          default:
            break;
        }
      }
      if (this.search) {
        str += "&userName=" + this.search;
      }
      Api.systemConfig.querySGManager(str, this.page, this.size).then((res) => {
        this.$nextTick(() => {
          this.tableData = res.data.list;
          this.total = res.data.total;
        });
      });
    },
    findclassmanagerload(Node) {
      this.page = 1;
      this.findclassmanager(Node);
    },
    findclassmanager(
      Node //查找节点下的班主任
    ) {
      this.bzrnode = Node;
      let user = store.getters.user;

      let str = "";
      switch (Node.type) {
        case "2":
          str = "collegeId=" + Node.relId;
          break;
        case "3":
          str = "departId=" + Node.relId;
          break;
        case "4":
          str = "gradeId=" + Node.relId;
          if (this.$refs.classtree.getNode(Node.parentId).data.type == 6) {
            str +=
              "&schoolNum=" +
              this.$refs.classtree.getNode(Node.parentId).data.relId;
          }
          break;
        case "5":
          str = "classId=" + Node.relId;
          break;
        case "6":
          str = "schoolNum=" + Node.relId;
          break;
        default:
          break;
      }

      if (this.search) {
        str += "&userName=" + this.search;
      }
      Api.systemConfig.querySGMaster(str, this.page, this.size).then((res) => {
        this.$nextTick(() => {
          this.headmastertableData = res.data.list;
          this.total = res.data.total;
        });
      });
    },
    searchrole(Node) {
      Api.systemConfig.querySchoolHouseTree(Node.id).then((res) => {
        this.tableData = res.data;
      });
    },
    // addcount() {
    //   this.addcountshow = true;
    //   this.buttonname = "上传照片";
    //   this.changecount("admin");
    // },
    changecount(val) {
      let user = session("user");
      this.img = null;
      switch (val) {
        case "admin":
          this.MasterDetailform = {
            roleId: this.adminroldid,
            roleCode: "admin",
            roleName: "学校管理员",
            mobile: "",
            password: "",
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: "",
            img: "",
          };
          this.schoolarea = "";
          this.newadmin = true;
          this.newkeeper = false;
          this.newmaster = false;

          break;
        case "housekeeper":
          this.MasterDetailform = {
            roleId: this.managerroldid,
            roleCode: "housekeeper",
            roleName: "宿舍管理员",
            houseIds: [],
            mobile: "",
            password: "",
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: "",
            img: "",
          };
          this.schoolarea = "";
          this.newadmin = false;
          this.newkeeper = true;
          this.newmaster = false;
          this.campusHouseList = [];

          break;
        case "headmaster":
          this.MasterDetailform = {
            roleId: this.masterroldid,
            roleCode: "headmaster",
            roleName: "班主任",
            mobile: "",
            classIds: "",
            password: "",
            schoolCode: user.schoolCode,
            schoolId: user.schoolId,
            schoolName: user.schoolName,
            sysCode: "suguan",
            sysId: 3,
            sysName: "宿管系统",
            userName: "",
            img: "",
          };
          this.tableData = [];
          let SchoolRelation = this.querySchoolRelationTree();
          SchoolRelation.then((res) => {
            if (res.code == 0) {
              let treedatadd = [];
              treedatadd.push(res.data);
              this.$nextTick(() => {
                this.classtreeData = treedatadd;
              });
            } else {
              this.$message(res.message);
            }
          });
          this.deptValueShow = false;
          this.classIdsname = "";
          this.newadmin = false;
          this.newkeeper = false;
          this.newmaster = true;

          break;
        default:
          break;
      }
    },
    changeSchoolCapmusHouseedit(capmusId) {
      let housePromise = this.getSchoolCapmusHouselist(capmusId);
      housePromise.then((houseRes) => {
        if (
          houseRes.code == 0 &&
          houseRes.data != null &&
          houseRes.data.length > 0
        ) {
          this.campusHouseList = houseRes.data;
        } else {
          this.campusHouseList = [];
        }
      });
    },
    changeSchoolCapmusHouse(capmusId) {
      let housePromise = this.getSchoolCapmusHouselist(capmusId);
      housePromise.then((houseRes) => {
        if (
          houseRes.code == 0 &&
          houseRes.data != null &&
          houseRes.data.length > 0
        ) {
          this.campusHouseList = houseRes.data;
          this.$nextTick(() => {
            this.keeperDetailform.houseIds = [];
            this.MasterDetailform.houseIds = [];
          });
        } else {
          this.campusHouseList = [];
        }
      });
    },
    getSchoolCapmusHouselist(capmusId) {
      return new Promise(function (resolve, reject) {
        let user = session("user");
        Api.summary.getAllHouseBySchool(user.schoolId, capmusId).then((res) => {
          if (res.code == 0) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    typechangeload(val) {
      switch (val) {
        case "logisticsadmin":
          this.tableData = [];
          let housetree1 = this.querySchoolHouseTree();
          housetree1.then((res) => {
            if (res.code == 0) {
              res.data.treeDTOList[0].children = null;
              this.admintreeData = res.data.treeDTOList;

              this.findLogisticsadminManager(this.admintreeData);
            } else {
              this.$message(res.message);
            }
          });

          break;
        case "admin":
          this.tableData = [];
          let housetree = this.querySchoolHouseTree();
          housetree.then((res) => {
            if (res.code == 0) {
              res.data.treeDTOList[0].children = null;
              this.admintreeData = res.data.treeDTOList;

              this.findadminmanager(this.admintreeData);
            } else {
              this.$message(res.message);
            }
          });

          break;
        case "housekeeper":
          this.tableData = [];
          let housetrees = this.querySchoolHouseTree();
          housetrees.then((res) => {
            if (res.code == 0) {
              this.$nextTick(() => {
                this.treeData = res.data.treeDTOList;

                this.findsushemanager(this.treeData);
              });
            } else {
              this.$layer.msg(res.message);
            }
          });

          break;
        case "headmaster":
          this.tableData = [];
          let SchoolRelation = this.querySchoolRelationTree();
          SchoolRelation.then((res) => {
            if (res.code == 0) {
              // let treedatadd = [];
              // treedatadd.push(res.data);
              this.$nextTick(() => {
                this.waiclasstreeData = res.data;
                this.findclassmanager(this.waiclasstreeData);
              });
            } else {
              this.$message(res.message);
            }
          });
          break;

        default:
          break;
      }
    },
    typechange(val) {
      this.page = 1;
      this.typechangeload(val);
    },
    querySchoolRelationTree() {
      let user = session("user");
      return new Promise((resolve, reject) => {
        Api.common
          .querySchoolRelationTree(user.schoolId)
          .then((res) => {
            // this.treeData = res.data.treeDTOList;
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    querySchoolHouseTree() {
      let user = session("user");
      return new Promise((resolve, reject) => {
        Api.systemConfig
          .querySchoolHouseTree(user.schoolId)
          .then((res) => {
            // this.treeData = res.data.treeDTOList;
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    querySchoolSysRoles() {
      Api.systemConfig.querySchoolSysRoles().then((res) => {
        if (res.data) {
          this.adminroldid = res.data[0].id;
          this.managerroldid = res.data[1].id;
          this.masterroldid = res.data[2].id;
        }
      });
    },
    loadData() {
      this.typechangeload(this.glytype);
    },
    // querySchoolHouseTree() {
    // 	let user = session('user');
    // 	Api.systemConfig.querySchoolHouseTree(user.schoolId).then(res => {
    // 		this.treeData = res.data.treeDTOList;

    // 	})
    // }
  },

  mounted() {
    this.getSchoolarealist();
    this.querySchoolSysRoles();
    console.log(this.user.style);
  },
};
</script>
<style lang="scss" scoped>
.leftmenu {
  width: 100%;
  display: block;
  .title {
    width: 100%;
    background: #25aef4;
    font-size: 16px;
    color: white;
    line-height: 40px;
    height: 40px;
    position: relative;
    text-indent: 1em;
    .res-booklist {
      position: absolute;
      width: 100%;
      height: 200px;
      overflow-y: auto;
      background: #fff;
      top: 43px;
      left: 0;
    }
  }
  .treepanel {
    width: 100%;
  }
}

.righttable {
  padding: 0 20px;
  .operation-panel {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #f0f0f0;
    .input {
      width: 300px;
      float: right;
      margin-top: 5px;
      .el-input__inner {
        border: 1px solid #26aef3;
        border-right: none;
      }
      .el-input-group__append {
        border: 1px solid #26aef3;
        border-left: none;
        background-color: #26aef3;
        color: #fff;
      }
    }
  }
}

.roleauthor {
  .el-form-item {
    .combotree {
      position: absolute;
      left: 0;
      top: 76px;
      z-index: 19920104;
      overflow: auto;
      height: 300px;
      min-width: 170px;
    }
  }
}

.import {
  margin-left: 20px;
}

.import:before {
  display: inline-block;
  vertical-align: middle;
  content: "";
  width: 18px;
  height: 18px;
  background-image: url("import.png");
}
</style>





// WEBPACK FOOTER //
// src/pages/systemConfig/roleAuthorizationConfig.vue